var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 4.1875H11.875C11.5562 4.1875 11.3125 4.43125 11.3125 4.75C11.3125 5.06875 11.5562 5.3125 11.875 5.3125H22C23.7625 5.3125 25.1875 6.7375 25.1875 8.5V24.25C25.1875 24.5688 25.4312 24.8125 25.75 24.8125C26.0688 24.8125 26.3125 24.5688 26.3125 24.25V8.5C26.3125 6.11875 24.3813 4.1875 22 4.1875Z",
    fill: "#9BA3AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.875 27.8125H20.875C22.225 27.8125 23.3125 26.725 23.3125 25.375V14.125C23.3125 13.8063 23.0688 13.5625 22.75 13.5625C22.4312 13.5625 22.1875 13.8063 22.1875 14.125V25.375C22.1875 26.1063 21.6062 26.6875 20.875 26.6875H8.875C8.14375 26.6875 7.5625 26.1063 7.5625 25.375V9.625C7.5625 8.89375 8.14375 8.3125 8.875 8.3125H18.4375V9.625C18.4375 10.975 19.525 12.0625 20.875 12.0625H22.75C23.0688 12.0625 23.3125 11.8187 23.3125 11.5C23.3125 10.3563 22.8625 9.26875 22.0563 8.44375C21.2313 7.6375 20.1438 7.1875 19 7.1875H8.875C7.525 7.1875 6.4375 8.275 6.4375 9.625V25.375C6.4375 26.725 7.525 27.8125 8.875 27.8125ZM19.5625 8.36875C20.2 8.48125 20.7812 8.78125 21.25 9.25C21.7188 9.71875 22.0187 10.3 22.1312 10.9375H20.875C20.1438 10.9375 19.5625 10.3563 19.5625 9.625V8.36875Z",
    fill: "#9BA3AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.9802f7911c63442cf62afef9174d357e.svg";
export { ForwardRef as ReactComponent };